module.exports = __webpack_public_path__ + "media/Temptation_March.284694f4.mp3";